export const SET_SIDE_PANEL_SELECTED_HOLIDAY =
  'SET_SIDE_PANEL_SELECTED_HOLIDAY';

export const setSidePanelSelectedHoliday = holiday => ({
  type: SET_SIDE_PANEL_SELECTED_HOLIDAY,
  payload: holiday,
});
